import { render } from "./htmlBoxView.vue?vue&type=template&id=549252ab&scoped=true"
import script from "./htmlBoxView.vue?vue&type=script&lang=js"
export * from "./htmlBoxView.vue?vue&type=script&lang=js"

import "./htmlBoxView.vue?vue&type=style&index=0&id=549252ab&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-549252ab"]])

export default __exports__